import AboutUsAdminBackground from "./AboutUsAdminBackground";

export default AboutUsAdminBackground;
